import { BATCH_LOAD, BATCH_LOAD_ERROR_MESSAGE } from '../action/batchLoad'

const initialState = {
  errorMsg : '',
  batchUploadResult : false
}

export default (state = initialState, action) => {
  const { type, payload } = action
  switch(type) {
    case BATCH_LOAD_ERROR_MESSAGE:
      return {
        ...state,
        errorMsg: payload.resultText || 'An error occurred'
      }
    case `${BATCH_LOAD}_FULFILLED`:
      if (payload.resultCode === "0") {

        return {
          ...state,
          batchUploadResult: payload.resultText
        }
      } else {
        return {
          ...state,
          errorMsg: payload.resultText
        }
      }
    case `${BATCH_LOAD}_PENDING`:
      return {
        ...state,
        errorMsg: ''
      }
    case `${BATCH_LOAD}_REJECTED`:
      return {
        ...state,
        errorMsg: 'Cannot connect to server'
      }
    case `${BATCH_LOAD}_RESET`:
      return {
        ...initialState
      }

    default:
      return state
  }
}
